import React, { useEffect, useState } from 'react';
import { useHeader } from '../header';
import { useAccountService } from '../services/account';
import { AccountBalance } from '../services/account/types';
import { useRewardableService } from '../services/rewardable';
import { TransactionGrid } from '../transaction';
import { TransactionGridContextProvider } from '../transaction/TransactionGridContext';
import { BalanceCards, CashOutModal } from './index';
import { BounceLoader } from '../loader';

const Dashboard = () => {
    const { setHeaderTitle, setHeaderSubTitle, closePaymentSettings } = useHeader();
    const accountService = useAccountService();
    const rewardableService = useRewardableService();
    const [accountBalance, setAccountBalance] = useState<AccountBalance>();
    const [isCashoutModalOpen, setIsCashoutModalOpen] = useState(false);

    useEffect(() => {
        setHeaderTitle('Dashboard');
        setHeaderSubTitle('See what your activity has earned you');
        rewardableService.triggerSync()
            .then(() => accountService.getAccountBalance())
            .then(accountBalanceResponse => {
                setAccountBalance(accountBalanceResponse);
            })
            .catch(console.error);
    }, [setHeaderTitle, setHeaderSubTitle, rewardableService, accountService]);

    const onCashOutSubmit = (amount: number) => {
        setAccountBalance(prev => prev && ({
            ...prev,
            pending: {
                ...prev.pending,
                debit: (prev.pending.debit ?? 0) + amount,
            },
        }));
        setIsCashoutModalOpen(false);
    }

    return (
        <>
            {!accountBalance ?
                <BounceLoader title="Loading dashboard" subTitle="Fetching your rewards..." />
                :
                <TransactionGridContextProvider>
                    <BalanceCards balanceInfo={accountBalance} onCashOut={() => { closePaymentSettings(); setIsCashoutModalOpen(true); }} />
                    <TransactionGrid/>
                </TransactionGridContextProvider>
            }
            {accountBalance && isCashoutModalOpen &&
                <CashOutModal
                    availableCash={accountBalance.cash - (accountBalance.pending.debit ?? 0)}
                    onClose={() => setIsCashoutModalOpen(false)}
                    onSubmit={onCashOutSubmit}
                />
            }
        </>
    );
};

export default Dashboard;